module.exports = __webpack_public_path__ + "static/media/5.1ec53cc6.png";